import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import { syncDeviceLanguage } from './i18n';
import Router from './Router';
import reportWebVitals from './reportWebVitals';
import { useExternalLinks } from './hooks/useExternalLinks';

syncDeviceLanguage();

function Root() {
  useExternalLinks();
  return <Router />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

reportWebVitals();
